export default __webpack_public_path__ + "static/fungus-a006e8d5ac6cb230bcbbd4c0a6d10885.webp";